<div class="payer">
    <div class="payer-details">
        <div class="carrier-name">{{ carrier.carrierName }}</div>
        <div class="is-mapped">{{ carrier.payerName }}</div>
    </div>
</div>
